export interface TimecardIncrementOption {
    label: string;
    value: number;
}

export const toTimecardIncrementOption = (value: number): TimecardIncrementOption => ({
    label: String(value),
    value,
});

/**
 * Builds the selectable timecard increment options from the tenant-configured values.
 * The currently selected value is appended when it is missing from the configuration,
 * so previously stored increments still display in the select.
 */
export const buildTimecardIncrementOptions = (
    configuredValues: number[] | null | undefined,
    currentValue: number | null | undefined
): TimecardIncrementOption[] => {
    const values = [...(configuredValues ?? [])];
    if (currentValue != null && !values.includes(currentValue)) {
        values.push(currentValue);
    }
    return values.sort((a, b) => a - b).map(toTimecardIncrementOption);
};
